module.exports = require("@splunk/visualization-encoding-parsers/SingleValueParser");